import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as actionsEstablecimiento from "../_redux/establecimiento/establecimientoActions";
import * as actionsPasoTres from "../_redux/pasoTres/pasoTresActions";
import * as _ from 'lodash';
import * as actionsDepartamento from "../../../Comun/Departamento/_redux/dptoActions";
import * as actionsLocalidad from "../../../Comun/Localidad/_redux/localidadActions";

//CONTEXO
import { PreInscripcionUIConsumer, PreInscripcionUIContext } from '../PreInscripcionUIContext';

//VISTA PARA VER LOS ESTABLECIMIENTOS SELECCIONADOS
import EstablecimientoCard from './components/EstablecimientoCard';

//ICONOS
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

//FORMIK
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';

//ICONOS USADOS
import ErrorIcon from '@material-ui/icons/Error';
import SearchIcon from '@material-ui/icons/Search';

//REACT BOOTSTRAP
import { Button ,Spinner} from 'react-bootstrap';

//BOTONES
import Volver from '../components/Volver';

//MATERIAL UI CARD  
import { Card, CardContent } from '@material-ui/core';

//SEARCH SELECT
import Select from 'react-select';

//RADIO BUTTONS
import { Radio, RadioGroup, FormControlLabel } from '@material-ui/core';

//SELECCIONAR DPTO Y LOCALIDAD
import SelectorDepartamento from "../../../../modules/Comun/Departamento/selector";
import SelectorLocalidad from "../../../../modules/Comun/Localidad/selector";
import SnackBarCustom from '../../../Comun/SnackBars/SnackBarCustom';

const SeleccionEstablecimiento = (props) => {
    const { nextStep } = props;
    
    const { establecimiento } = useSelector(
        (state) => ({ establecimiento: state.establecimiento }),
        shallowEqual
    );
    const {
        entities: establecimientosList,
        //hermanoEstab,
        //familiarEstab,
        listLoading: listLoadingEstablecimientos,
        error: errorListadoEstablecimientos
    } = establecimiento;

    const { pasoUno } = useSelector(
        (state) => ({ pasoUno: state.pasoUno }),
        shallowEqual
    );
    const { inscripcionId } = pasoUno;

    const { pasoDos } = useSelector(
        (state) => ({ pasoDos: state.pasoDos }),
        shallowEqual
    );

    const {
        establecimientos: seleccionadosPaso2,
        // actionsLoading: actionsLoadingPaso2,
        // error: errorPaso2
    } = pasoDos;

    const { pasoTres } = useSelector(
        (state) => ({ pasoTres: state.pasoTres }),
        shallowEqual
    );

    const {
        actionsLoading: actionsLoadingPaso3,
        //extrasInformacion: extrasInformacionPaso3,
        error: errorPaso3
    } = pasoTres;

    const { nivelSeleccionado, dispatchDatosPeronales } = useContext(PreInscripcionUIContext);
    const { nivel, grado } = nivelSeleccionado();
    //FILTRO PARA UBICACION
    const [departamento, setDepartamento] = useState(0);
    const [localidades, setLocalidades] = useState([])//aca van las localidades filtradas por dpto
    const [localidad, setLocalidad] = useState(0);
    //GUARDA LOS ESTABLECIMIENTOS SELECCIONADOS
    //const [establecimientos, setEstablecimientos] = useState([]);
    const [seleccionados, setSeleccionados] = useState([]);
    const [primeraCarga, setPrimeraCarga] = useState(true)
    //COMO EN EL SEARCH NO SE USA FORMULARIO, SE USA ESTA BANDERA PARA EL ERROR SI NO CARGO ESTABLECIMIENTOS
    const [tocoSearch, setTocoSearch] = useState(false);
    //SE USA EN VARIAS PARTES, PARA LOS BOTONES DE PRIORIDAD Y LAS PREGUNTAS DEL ESTABLECIMIENTO
    const [ultimoEstablecimiento, setUltimoEstablecimiento] = useState(0);
    //ACTIVA LAS OPCIONES PARA AGREGAR INFORMACION A LOS ESTABLECIMIENTOS SELECCIONADOS
    const [hermano, setHermano] = useState(false);
    const [familiar, setFamiliar] = useState(false);
    const [vincular, setVincular] = useState(false);
    //ACTIVA LAS PREGUNTAS DE LOS ESTABLECIMIENTOS SELECCIONADOS
    const [preguntas, setPreguntas] = useState(false);

    const seleccionarEstablecimiendo = (item) => {
        if (seleccionados.length < 6) {
            if (seleccionados) {
                setUltimoEstablecimiento(seleccionados.length + 1);
            } else {
                setUltimoEstablecimiento(0);
            };
            setSeleccionados([...seleccionados, item]);
            setPreguntas(true);
        };
    };
    function quitarEstablecimiento(item) {
        if (primeraCarga) {
            setPrimeraCarga(false);
        };

        setSeleccionados(seleccionados.filter(filtrado => filtrado.ofertaId !== item.ofertaId));
        if (seleccionados) {
            setUltimoEstablecimiento(seleccionados.length + 1);
        } else {
            setUltimoEstablecimiento(0);
        };

    };
    function permutarArriba(i) {
        if (i > 0) {
            let item = seleccionados[i];
            item.prioridad = i;
            let itemAnterior = seleccionados[i - 1];
            itemAnterior.prioridad = i + 1;
            let nuevaLista = seleccionados.slice();
            nuevaLista[i] = itemAnterior;
            nuevaLista[i - 1] = item;
            setSeleccionados(nuevaLista);
        };
    };
    function permutarAbajo(i) {
        if (i < 4) {
            let item = seleccionados[i];
            item.prioridad = i + 2;
            let itemSiguiente = seleccionados[i + 1];
            itemSiguiente.prioridad = i + 1;
            let nuevaLista = seleccionados.slice();
            nuevaLista[i + 1] = item;
            nuevaLista[i] = itemSiguiente;
            setSeleccionados(nuevaLista);
        };
    };
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    //ESQUEMA NORMAL
    const modalSchema = Yup.object().shape({
        fueEstatal: Yup.boolean()
            .required("Debe seleccionar una opción").default(false),
        fueAbanderaro: Yup.boolean()
            .required("Debe seleccionar una opción").default(false),
        tieneVinculacion: Yup.boolean()
            .required("Debe seleccionar una opción").default(false),
    });
    //ESQUEPA PARA LA OPCION DE SI TIENE HERMANOS EN EL ESTABLECIMIENTO
    const hermanoSchema = Yup.object().shape({
        hermanoSexo: Yup.string()
            .required("Debe seleccionar el sexo"),
        hermanoNombre: Yup.string()
            .min(2, "El nombre debe tener 2 caracteres mínimo")
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1']+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1']*)*[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/g, "El nombre debe estar compuesto solo por letras")
            .required("Debe ingresar al menos un nombre"),
        hermanoApellido: Yup.string()
            .min(2, "El apellido debe tener 2 caracteres mínimo")
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1']+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1']*)*[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/g, "El apellido debe estar compuesto solo por letras")
            .required("Debe ingresar al menos un  apellido"),
        hermanoNumeroDocumento: Yup.string()
            .matches(/^\d+$/, "Solo debe ingresar números")
            .required("Debe seleccionar una opción"),
        hermanoGrado: Yup.string()
            .required("Debe seleccionar una opción"),
    });
    //ESQUEMA PARA LA OPCION SI TIENE FAMILIAR EN EL ESTABLECIMIENTO
    const familiarSchema = Yup.object().shape({
        familiarSexo: Yup.string()
            .required("Debe seleccionar el sexo"),
        familiarNombre: Yup.string()
            .min(2, "El nombre debe tener 2 caracteres mínimo")
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1']+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1']*)*[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/g, "El nombre debe estar compuesto solo por letras")
            .required("Debe ingresar al menos un nombre"),
        familiarApellido: Yup.string()
            .min(2, "El apellido debe tener 2 caracteres mínimo")
            //.matches(/^[a-zA-ZÀ-ÿ\u00f1\u00d1']+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1']*)*[a-zA-ZÀ-ÿ\u00f1\u00d1']+$/g, "El apellido debe estar compuesto solo por letras")
            .required("Debe ingresar al menos un  apellido"),
        familiarNumeroDocumento: Yup.string()
            .matches(/^\d+$/, "Solo debe ingresar números")
            .required("Debe seleccionar una opción"),
        familiarVinculo: Yup.string()
            //.matches(/^[A-Za-z\s]+$/, "El vinculo debe estar compuesto solo por letras")
            .required("Debe seleccionar una opción"),
    });
    //ESQUEMA PARA LA OPCION DE VINCULAR OTRA INSCRIPCION
    const vincularSchema = Yup.object().shape({
        vinculacionNumero: Yup.string()
            .matches(/^\w+$/, "Solo debe ingresar números y letras")
            .min(6, "Debe ingresar 6 carácteres o mas")
            .max(9, "Solo se permiten 9 carácteres")
            .required("Debe ingresar el número de inscripción"),
    });
    //ESQUEMA CON TODAS LAS OPCIONES
    const modalFullSchema = modalSchema.clone().concat(hermanoSchema).concat(familiarSchema).concat(vincularSchema);
    //VALORES INICIALES PARA LOS ESQUEMAS
    const valoresIniciales = {
        tieneHermano: false,
        hermanoSexo: "",
        hermanoNumeroDocumento: "",
        hermanoApellido: "",
        hermanoNombre: "",
        hermanoGrado: "",
        tieneFamiliar: false,
        familiarSexo: "",
        familiarNumeroDocumento: "",
        familiarApellido: "",
        familiarNombre: "",
        familiarVinculo: "",
        turno: "",
        tieneVinculacion: false,
        vinculacionNumero: ""
    };

    const getNivelEnsenanzaId = (nivelDescripcion) => {
        switch (nivelDescripcion) {
            case 'Inicial':
                return 1;
            case 'Primario':
                return 2;
            case 'Secundario':
                return 3;
            default:
                return null;
        }
    }

    const getCursoId = (cursoDescripcion) => {
        switch (cursoDescripcion) {
            case 'Sala de 4':
                return 1;
            case 'Sala de 5':
                return 2;
            case '1º':
                return 5;
            default:
                return null;
        }
    }

    const dispatch = useDispatch();

    const [seleccionadosPaso2Ext, setSeleccionadosPaso2Ext] = useState([]);

    useEffect(() => {
        if (nivel) {
            dispatch(actionsEstablecimiento.fetchEstablecimientos({
                departamentoId: !departamento ? null : departamento.departamentoId,
                localidadId: !localidad ? null : localidad.localidadId,
                nivelEnsenanzaId: getNivelEnsenanzaId(nivel),
                cursoId: getCursoId(grado),
                turnoId: null,
                esSeleccionable: true
            }));
        }
    }, [nivel, localidad, departamento, grado, dispatch]);

    useEffect(() => {
        if (seleccionados.length === 0 && primeraCarga 
            && !!seleccionadosPaso2 && seleccionadosPaso2.length > 0 
            && !!establecimientosList && !!establecimientosList.length > 0) {
            let seleccionadosPaso2Aux = JSON.parse(JSON.stringify(seleccionadosPaso2));;
            setSeleccionadosPaso2Ext(seleccionadosPaso2Aux.map(oferta => {
                if (!oferta.establecimiento || oferta.establecimiento.length === 0) {
                    let ofertaTemp = JSON.parse(JSON.stringify(oferta));
                    let aux = _.head(_.filter(establecimientosList, function (establecimiento) {
                        if (establecimiento.ofertaId === oferta.ofertaId) {
                            return establecimiento;
                        }
                    }));
                    ofertaTemp.establecimiento = aux.establecimiento;
                    ofertaTemp.direccion = aux.direccion;
                    ofertaTemp.cueAnexo = aux.cueAnexo;
                    ofertaTemp.localidad = aux.localidad;
                    ofertaTemp.departamento = aux.departamento;
                    ofertaTemp.vacante = aux.vacante;
                    
                    return ofertaTemp;
                };
            }));
        }
    }, [seleccionadosPaso2, establecimientosList, seleccionados, primeraCarga]);

    useEffect(() => {
        if (!actionsLoadingPaso3 && !errorPaso3 && tocoSearch) {
            setTimeout(() => {
                dispatchDatosPeronales({ type: 'guardarEstablecimientos', payload: { establecimientos: seleccionados } });
                dispatch(actionsDepartamento.fetchDepartamentos({soloConOfertas: false}));
                dispatch(actionsLocalidad.fetchLocalidades({soloConOfertas: false}));
                nextStep();
            }, 500);
        };
    }, [actionsLoadingPaso3, errorPaso3]);

    let establecimientosFiltrados = establecimientosList && _.differenceWith(establecimientosList, seleccionados, (arrVal, othVal) => arrVal.ofertaId === othVal.ofertaId);
    let cantidadMaxima = establecimientosFiltrados && ((establecimientosFiltrados.length > 2 ? 3 : establecimientosFiltrados.length) || 1);

    return (
        <PreInscripcionUIConsumer>
            {value =>
                <>
                    {seleccionados.length === 0 && primeraCarga && setSeleccionados(seleccionadosPaso2Ext)}
                    {seleccionados && seleccionados.length > 0 && setUltimoEstablecimiento(seleccionados.length)}
                    <Card style={{ backgroundColor: "#f7f7f7" }}>
                        <CardContent className="d-flex flex-row align-items-center ml-2">
                            <div className="border-left border-2 border-warning p-3 br-4">
                                <ErrorIcon className="text-warning" fontSize="large" />
                            </div>
                            <div>
                                <b>IMPORTANTE</b>
                                <p>Usted podrá optar hasta 5 (cinco) opciones correspondientes a instituciones educativas de su preferencia. Puede ordernarlas por prioridad</p>
                            </div>
                        </CardContent>
                    </Card>
                    <br />
                    <h3 className="text-center" >SELECCIÓN DE ESTABLECIMIENTO</h3>
                    <div className="d-flex flex-row justify-content-between">
                        <p className="font-weight-bold">Seleccionar Institución Educativa</p>
                        <p className="text-muted">(*)Campos Obligatorios</p>
                    </div>
                    <div className="form-group">
                        <label htmlFor="grado">Nivel Seleccionado: <b>{nivel} - {nivel === "Inicial" ? grado : grado + "Año de " + nivel}</b></label>
                    </div>
                    <h4 className="text-center mb-2">Solo encontrará establecimientos con vacantes disponibles</h4>
                    <div className="row justify-content-between align-items-top" >
                        <div className="form-group col-12 col-sm-6">
                            <label>Seleccionar Departamento</label>
                            <SelectorDepartamento setLocalidadesChild={setLocalidades} setLocalidadChild={setLocalidad} setDepartamentoChild={setDepartamento} />
                        </div>
                        <div className="form-group col-12 col-sm-6">
                            <label>Seleccionar Localidad</label>
                            <SelectorLocalidad setLocalidadChild={setLocalidad} localidadesChild={localidades} localidadChild={localidad} />
                        </div>
                    </div>

                    {!listLoadingEstablecimientos ?
                        <div className="form-group ">
                            <div className="row justify-content-center text-success">
                                <div className="d-none d-sm-block" ><ArrowDownwardIcon fontSize="small" /></div>
                                <label className="text-success ml-2 mr-2">Busque sus establecimientos aquí</label>
                                <div><ArrowDownwardIcon fontSize="small" /></div>
                            </div>
                            <div className="input-group">
                                <div className="input-group-prepend" >
                                    <label className="input-group-text bg-white" ><SearchIcon /></label>
                                </div>
                                <Select
                                    className="form-control m-0 p-0 b-0 basic-multi-select"
                                    placeholder="Buscar establecimientos"
                                    isLoading={listLoadingEstablecimientos}
                                    value={""}
                                    options={establecimientosFiltrados}
                                    getOptionValue={({ ofertaId }) => ofertaId}
                                    getOptionLabel={({ 
                                        cueAnexo, 
                                        establecimiento, 
                                        direccion, 
                                        departamento, 
                                        localidad, 
                                        turno, 
                                        curso }) => `${establecimiento} - Turno: ${turno} ${!!curso && curso.toUpperCase() === 'PLURISALA' ? ' - PLURISALA' : ''}`}
                                    onChange={seleccionarEstablecimiendo}
                                    onBlur={() => setTocoSearch(true)}
                                    isDisabled={preguntas || !(departamento && localidad)}
                                    isSearchable
                                    noOptionsMessage={() => "No hay mas establecimientos"}
                                />
                            </div>
                            {tocoSearch && seleccionados.length < cantidadMaxima &&
                                <div className="row justify-content-center text-danger mt-1">
                                    <div className="d-none d-sm-block"><ArrowUpwardIcon fontSize="small" /></div>
                                    <label className="text-danger" >Debe seleccionar al menos {cantidadMaxima} establecimiento</label>
                                    <div className="d-none d-sm-block"><ArrowUpwardIcon fontSize="small" /></div>
                                </div>
                            }
                        </div>
                        :
                        <div className="text-warning text-center mb-4"> Aguarde unos segundos, los establecimientos están siendo buscados... </div>
                    }

                    {preguntas ?
                        <Formik
                            initialValues={valoresIniciales}
                            //SE VAN USANDO DIFERENTES ESQUEMAS SEGUN LAS OPCIONES SELECCIONADAS
                            //POR FAVOR NO AGREGUEN MAS OPCIONES
                            validationSchema={
                                hermano && familiar && vincular ? modalFullSchema :
                                    hermano && !familiar && !vincular ? hermanoSchema.concat(modalSchema) :
                                        hermano && familiar && !vincular ? hermanoSchema.concat(modalSchema).concat(familiarSchema) :
                                            hermano && !familiar && vincular ? hermanoSchema.concat(modalSchema).concat(vincularSchema) :
                                                familiar && !hermano && !vincular ? familiarSchema.concat(modalSchema) :
                                                    familiar && hermano && !vincular ? familiarSchema.concat(modalSchema).concat(hermanoSchema) :
                                                        familiar && !hermano && vincular ? familiarSchema.concat(modalSchema).concat(vincularSchema) :
                                                            vincular && !hermano && !familiar ? vincularSchema.concat(modalSchema) :
                                                                modalSchema
                            }
                            onSubmit={(values, { setSubmitting }) => {
                                setTimeout(() => {
                                    let nuevaLista = {};
                                    let familiar = {};
                                    let hermano = {}
                                    let vinculoFamiliar = {}
                                    //LOS 3 SIGUIENTES IF LIMPIAN LOS VALORES DEL FORMULARIO SI LA BANDERA CORRESPONDIENTE ES IGUAL A FALSE

                                    if (!values.tieneFamiliar) {
                                        familiar = null;
                                        values.familiarSexo = "";
                                        values.familiarNumeroDocumento = "";
                                        values.familiarApellido = "";
                                        values.familiarNombre = "";
                                        values.familiarVinculo = "";
                                        values.familiarVinculoId = 0;
                                    } else {
                                        familiar.id = null;
                                        familiar.sexo = values.familiarSexo;
                                        familiar.nroDocumento = values.familiarNumeroDocumento;
                                        familiar.apellido = values.familiarApellido;
                                        familiar.nombre = values.familiarNombre;
                                        const { vinculoId } = value.vinculos.find(item => item.nombre === values.familiarVinculo);
                                        values.familiarVinculoId = vinculoId;
                                        vinculoFamiliar.id = values.familiarVinculoId ? values.familiarVinculoId : null;
                                        vinculoFamiliar.descripcion = values.familiarVinculo
                                    };
                                    if (!values.tieneHermano) {
                                        hermano = null;
                                        values.hermanoSexo = "";
                                        values.hermanoNumeroDocumento = "";
                                        values.hermanoApellido = "";
                                        values.hermanoNombre = "";
                                        values.hermanoGrado = "";
                                    } else {
                                        hermano.id = null;
                                        hermano.sexo = values.hermanoSexo;
                                        hermano.nroDocumento = values.hermanoNumeroDocumento;
                                        hermano.apellido = values.hermanoApellido;
                                        hermano.nombre = values.hermanoNombre;
                                    };
                                    if (!values.tieneVinculacion) {
                                        values.vinculacionNumero = "";
                                    };
                                    //GUARDAR LOS VALORES DEL FORMULARIO EN LA POSICION DEL ULTIMO ESTABLECIMIENTO SELECCIONADO
                                    const i = ultimoEstablecimiento - 1;

                                    nuevaLista = Object.assign(nuevaLista, { familiar }, { vinculoFamiliar }, { hermano });
                                    nuevaLista.id = null;
                                    nuevaLista.nivelCursoAnio = values.hermanoGrado;
                                    nuevaLista.inscripcionId = inscripcionId ? inscripcionId : null;
                                    nuevaLista.ofertaId = seleccionados[i].ofertaId;
                                    nuevaLista.ofertaSeleccionadaId = seleccionados[i].ofertaSeleccionadaId;
                                    nuevaLista.llamado = seleccionados[i].llamado;
                                    nuevaLista.turno = seleccionados[i].turno;
                                    nuevaLista.turnoId = seleccionados[i].turnoId;
                                    nuevaLista.direccion = seleccionados[i].direccion;
                                    nuevaLista.establecimiento = seleccionados[i].establecimiento;
                                    nuevaLista.vacantes = seleccionados[i].vacantes;
                                    nuevaLista.nivelEnsenanza = seleccionados[i].nivelEnsenanza;
                                    nuevaLista.nivelEnsenanzaId = seleccionados[i].nivelEnsenanzaId;
                                    nuevaLista.curso = seleccionados[i].curso;
                                    nuevaLista.cursoId = seleccionados[i].cursoId;
                                    nuevaLista.localidad = seleccionados[i].localidad;
                                    nuevaLista.localidadId = seleccionados[i].localidadId;
                                    nuevaLista.departamento = seleccionados[i].departamento;
                                    nuevaLista.departamentoId = seleccionados[i].departamentoId;
                                    nuevaLista.prioridad = i + 1;
                                    nuevaLista.codigoInscripcionVinculada = values.vinculacionNumero ? values.vinculacionNumero : "";
                                    nuevaLista.vinculoFamiliarId  = values.vinculoFamiliarId  ? values.vinculoFamiliarId  : 0;

                                    let nuevaSelect = seleccionados;
                                    nuevaSelect.splice(i, 1);
                                    setSeleccionados([...nuevaSelect, nuevaLista]);
                                    //LIMPIAMOS LAS BANDERAS
                                    setPreguntas(false);
                                    setFamiliar(false);
                                    setHermano(false);
                                    setVincular(false);
                                    setSubmitting(false);
                                }, 400);
                            }}
                        >
                            {formik =>
                                <Form>
                                    <h3>Datos Relevantes: {seleccionados[ultimoEstablecimiento - 1].nombre}</h3>
                                    <div className="form-group">
                                        {/*formik.values.turno.length === 0 && formik.setFieldValue("turno", seleccionados[ultimoEstablecimiento - 1].turnos[0])*/}
                                        <p>Este establecimiento tiene turno <b>{seleccionados[ultimoEstablecimiento - 1].turnoDescripcion}</b></p>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="tieneHermano">¿El aspirante tiene algún hermana/o cursando en este establecimiento?</label>
                                        <RadioGroup aria-label="position" id="tieneHermano" value={hermano}
                                            onChange={() => {
                                                formik.setFieldValue("tieneHermano", !formik.values.tieneHermano);
                                                setHermano(!hermano);
                                            }}
                                            row
                                        >
                                            <FormControlLabel value={true} control={<Radio color="primary" />} label="Si" />
                                            <FormControlLabel value={false} control={<Radio color="primary" />} label="No" />
                                        </RadioGroup>
                                    </div>
                                    {hermano &&
                                        <>
                                            <div className="row justify-content-between align-items-end" >
                                                <div className="form-group col-12 col-sm-6" >
                                                    <label htmlFor="hermanoSexo">Seleccionar Sexo*</label>
                                                    <Field name="hermanoSexo" as="select" className="form-control" >
                                                        {formik.values.hermanoSexo.length === 0 && <option value="">Sexo</option>}
                                                        <option value="M">Masculino</option>
                                                        <option value="F">Femenino</option>
                                                    </Field>
                                                    <div className="text-danger"><ErrorMessage name="hermanoSexo" /></div>
                                                </div>
                                                <div className="form-group col-12 col-sm-6">
                                                    <label htmlFor="hermanoNumeroDocumento">Ingrese Número de Documento del Hermana/o*</label>
                                                    <Field name="hermanoNumeroDocumento" type="text" className="form-control" placeholder="Número de Documento" maxLength={value.maxDocumentoNumero} />
                                                    <div className="text-danger"><ErrorMessage name="hermanoNumeroDocumento" /></div>
                                                </div>
                                            </div>
                                            <div className="row justify-content-center">
                                                {/*!formik.errors.hermanoSexo && formik.touched.hermanoSexo &&
                                                    !formik.errors.hermanoNumeroDocumento && formik.touched.hermanoNumeroDocumento &&
                                                    <Button variant="success" size="sm" onClick={() => {
                                                        dispatch(actionsEstablecimiento.fetchHermano({ sexo: formik.values.hermanoSexo, nroDocumento: formik.values.hermanoNumeroDocumento }))
                                                    }}>Buscar</Button>
                                                */}
                                            </div>
                                            <div className="row justify-content-between align-items-top" >
                                                <div className="form-group col-12 col-sm-6">
                                                    <label htmlFor="hermanoApellido">Ingresar Apellido del Hermana/o*</label>
                                                    <Field name="hermanoApellido" type="text" className="form-control" placeholder="Apellido" maxLength={value.maxApellido} />
                                                    <div className="text-danger"><ErrorMessage name="hermanoApellido" /></div>
                                                </div>
                                                <div className="form-group col-12 col-sm-6">
                                                    <label htmlFor="hermanoNombre">Ingresar Nombre del Hermana/o*</label>
                                                    <Field name="hermanoNombre" type="text" className="form-control" placeholder="Nombre" maxLength={value.maxNombre} />
                                                    <div className="text-danger"><ErrorMessage name="hermanoNombre" /></div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="hermanoGrado">Seleccione Grado / Año*</label>
                                                <Field className="form-control" name="hermanoGrado" as="select" >
                                                    {formik.values.hermanoGrado.length === 0 && <option value="">Grado / Año</option>}
                                                    <option value="Sala de 4">Sala de 4</option>
                                                    <option value="Sala de 5">Sala de 5</option>
                                                    <option value="1º">1º</option>
                                                    <option value="2º">2º</option>
                                                    <option value="3º">3º</option>
                                                    <option value="4º">4º</option>
                                                    <option value="5º">5º</option>
                                                    <option value="6º">6º</option>
                                                    <option value="7º">7º</option>
                                                </Field>
                                                <div className="text-danger"><ErrorMessage name="hermanoGrado" /></div>
                                            </div>
                                        </>
                                    }
                                    <div className="form-group">
                                        <label htmlFor="tieneFamiliar">¿El aspirante tiene algún familiar que trabaje en este establecimiento?</label>
                                        <RadioGroup aria-label="position" id="tieneFamiliar" value={familiar}
                                            onChange={() => {
                                                formik.setFieldValue("tieneFamiliar", !formik.values.tieneFamiliar);
                                                setFamiliar(!familiar);
                                            }}
                                            row
                                        >
                                            <FormControlLabel value={true} control={<Radio color="primary" />} label="Si" />
                                            <FormControlLabel value={false} control={<Radio color="primary" />} label="No" />
                                        </RadioGroup>
                                    </div>
                                    {familiar &&
                                        <>
                                            <div className="row justify-content-between align-items-end" >
                                                <div className="form-group col-12 col-sm-6" >
                                                    <label htmlFor="familiarSexo">Seleccionar Sexo*</label>
                                                    <Field name="familiarSexo" as="select" className="form-control" >
                                                        {formik.values.familiarSexo.length === 0 && <option value="">Sexo</option>}
                                                        <option value="M">Masculino</option>
                                                        <option value="F">Femenino</option>
                                                    </Field>
                                                    <div className="text-danger"><ErrorMessage name="familiarSexo" /></div>
                                                </div>
                                                <div className="form-group col-12 col-sm-6">
                                                    <label htmlFor="familiarNumeroDocumento">Ingrese Número de Documento del Familiar*</label>
                                                    <Field name="familiarNumeroDocumento" type="text" className="form-control" placeholder="Número de Documento" maxLength={value.maxDocumentoNumero} />
                                                    <div className="text-danger"><ErrorMessage name="familiarNumeroDocumento" /></div>
                                                </div>
                                            </div>
                                            <div className="row justify-content-center">
                                                {/*!formik.errors.familiarSexo && formik.touched.familiarSexo &&
                                                    !formik.errors.familiarNumeroDocumento && formik.touched.familiarNumeroDocumento &&
                                                    <Button variant="success" size="sm" onClick={() => {
                                                        dispatch(actionsEstablecimiento.fetchFamiliar({ sexo: formik.values.familiarSexo, nroDocumento: formik.values.familiarNumeroDocumento }))
                                                    }}>Buscar</Button>
                                                */}
                                            </div>
                                            <div className="row justify-content-between align-items-top" >
                                                <div className="form-group col-12 col-sm-6">
                                                    <label htmlFor="familiarApellido">Ingresar Apellido del Familiar*</label>
                                                    <Field name="familiarApellido" type="text" className="form-control" placeholder="Apellido" maxLength={value.maxApellido} />
                                                    <div className="text-danger"><ErrorMessage name="familiarApellido" /></div>
                                                </div>
                                                <div className="form-group col-12 col-sm-6">
                                                    <label htmlFor="familiarNombre">Ingresar Nombre del Familiar*</label>
                                                    <Field name="familiarNombre" type="text" className="form-control" placeholder="Nombre" maxLength={value.maxNombre} />
                                                    <div className="text-danger"><ErrorMessage name="familiarNombre" /></div>
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="familiarVinculo">Seleccione Vinculo*</label>
                                                <Field name="familiarVinculo" type="text" className="form-control" as="select" >
                                                    {formik.values.familiarVinculo.length === 0 && <option value="">Vinculo</option>}
                                                    <option value="Madre">Madre</option>
                                                    <option value="Padre">Padre</option>
                                                    {/*<option value="Abuela/o">Abuela/o</option>*/}
                                                </Field>
                                                <div className="text-danger"><ErrorMessage name="familiarVinculo" /></div>
                                            </div>
                                        </>
                                    }
                                    <div className="form-group">
                                        <label htmlFor="tieneVinculacion">Si ha realizado la inscripción de un hermano del aspirante en este establecimiento, seleccione SI e ingrese el DNI del hermano.</label>
                                        <RadioGroup aria-label="position" id="tieneVinculacion" value={vincular}
                                            onChange={() => {
                                                formik.setFieldValue("tieneVinculacion", !formik.values.tieneVinculacion);
                                                setVincular(!vincular);
                                            }}
                                            row
                                        >
                                            <FormControlLabel value={true} control={<Radio color="primary" />} label="Si" />
                                            <FormControlLabel value={false} control={<Radio color="primary" />} label="No" />
                                        </RadioGroup>
                                    </div>
                                    {vincular &&
                                        <div className="form-group">
                                            <label htmlFor="vinculacionNumero">Ingresar el DNI del hermano</label>
                                            <Field className="form-control" name="vinculacionNumero" type="text" placeholder="DNI" maxLength={9} />
                                            <div className="text-danger"><ErrorMessage name="vinculacionNumero" /></div>
                                        </div>
                                    }
                                    <div className="row justify-content-center">
                                        <Button variant="success" type="submit" >Aceptar</Button>
                                    </div>
                                </Form>
                            }
                        </Formik>
                        :
                        <>
                            {seleccionados && seleccionados.map((item, i) =>
                                <EstablecimientoCard
                                    key={i}
                                    i={i}
                                    item={item}
                                    permutarArriba={permutarArriba}
                                    permutarAbajo={permutarAbajo}
                                    quitarEstablecimiento={quitarEstablecimiento}
                                    ultimoEstablecimiento={ultimoEstablecimiento}
                                />
                            )}
                            <div className="row justify-content-center">
                                <Volver {...props} />
                                <Button className="ml-4" variant="success" size="sm" style={{ width: 115 }}
                                    onClick={() => {
                                        scrollTop();
                                        if (seleccionados.length < cantidadMaxima) {
                                            setTocoSearch(true);
                                        } else {
                                            const params = {
                                                inscripcionId: inscripcionId,
                                                ofertasSeleccionadas: seleccionados.map(oferta => {
                                                    return {
                                                        ofertaSeleccionadaId: oferta.ofertaSeleccionadaId,
                                                        prioridad: oferta.prioridad,
                                                        ofertaId: oferta.ofertaId,
                                                        llamadoId: 0,
                                                        llamado: oferta.llamado,
                                                        nivelEnsenanzaId: oferta.nivelEnsenanzaId,
                                                        nivelEnsenanza: oferta.nivelEnsenanza,
                                                        cursoId: oferta.cursoId,
                                                        curso: oferta.curso,
                                                        turnoId: oferta.turnoId,
                                                        turno: oferta.turno,
                                                        vacante: 0,
                                                        hermanoId: 0,
                                                        hermanoSexo: oferta.hermano && oferta.hermano.sexo,
                                                        hermanoNroDocumento: oferta.hermano && oferta.hermano.nroDocumento,
                                                        hermanoNombre: oferta.hermano && oferta.hermano.nombre,
                                                        hermanoApellido: oferta.hermano && oferta.hermano.apellido,
                                                        hermanoPersonaRegistroCivilId: 0,
                                                        familiarId: 0,
                                                        familiarSexo: oferta.familiar && oferta.familiar.sexo,
                                                        familiarNroDocumento: oferta.familiar && oferta.familiar.nroDocumento,
                                                        familiarNombre: oferta.familiar && oferta.familiar.nombre,
                                                        familiarApellido: oferta.familiar && oferta.familiar.apellido,
                                                        familiarPersonaRegistroCivilId: 0,
                                                        vinculoFamiliar: oferta.vinculoFamiliar && oferta.vinculoFamiliar.decripcion,
                                                        vinculoFamiliarId: oferta.vinculoFamiliarId || (oferta.vinculoFamiliar && oferta.vinculoFamiliar.id),
                                                        codigoInscripcionVinculada: oferta.codigoInscripcionVinculada,
                                                        nroDocumentoAspiranteVinculado: ""
                                                    }
                                                })
                                            };
                                            dispatch(actionsPasoTres.fetchPasoTresAlCuatro(params));
                                        };
                                    }}
                                >
                                    Continuar {actionsLoadingPaso3
                                        ? <Spinner animation="border" variant="light" size="sm" />
                                        : <ArrowForwardIcon />}
                                </Button>
                            </div>
                        </>
                    }
                    {errorPaso3 && <SnackBarCustom tipo="error" mensaje={errorPaso3} />}
                </>
            }
        </PreInscripcionUIConsumer >
    )
}

export default SeleccionEstablecimiento;